import { API, API_POST } from "../../Config";

export const handleAddDietCategory = (category, id) => {
  const f = new FormData();
  f.append("category", category);

  if (id) {
    
    f.append("id", id);
    return API_POST(API.updatedietcategory, f);
  }

  return API_POST(API.adddietcategory, f);
};
